import React, { Component } from 'react';
import $ from 'jQuery';

// import camera from '../../../assets/js/camera.min.js'
export default class Footer extends Component {


  render() {
    return (
      <footer id="footer">

        <div className="container">
          <div className="row">
            <div className="footerbottom">

              <div className="col-md-2">
              </div>
              <div className="col-md-2">
              </div>
              <div className="col-md-4">
                <div className="footerwidget">
                  <h4 className="overh4">
                    Donatii
              </h4>
                  <div >
                    <ul className="menu">
                      <li><p>Cont Euro: RO97BTRLEURCRT0282041001</p></li>
                      <li><p>Cont RON:  RO50BTRLRONCRT0282041001</p></li>
                      <li><p>Titular cont: Asociatia Umanitara "Dreptul la viata" Huedin</p></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="footerwidget">
                  <h4 className="overh4">Contact</h4>
                  <p>Asociaţia Umanitară “Dreptul la viaţă” Huedin</p>
                  <div className="contact-info">
                    <i className="fa fa-map-marker"></i> Piaţa Republicii nr.8, loc. Huedin, jud. Cluj<br />
                    {/* <i className="fa fa-phone"></i>+00 123 156 711 <br /> */}
                    <i className="fa fa-envelope-o"></i> contact@dreptullaviata.ro <br />
                    <a href="https://www.facebook.com/asociatiadreptullaviatahuedin/" color="#65b733 !important" style = {{color:"#65b733"}}><i className="fa fa-facebook"></i>  Asociaţia Umanitară "Dreptul la viaţă"- Huedin</a> 
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="social text-center">
          </div>

          <div className="clear"></div>

        </div>
        <div className="footer2">
          <div className="container">
            <div className="row">

              <div className="col-md-8 panel">
                <div className="panel-body">
                  <p className="simplenav">
                    <a href="home">Acasa</a> |
                      <a href="about">Despre</a> |
                      <a href="projects">Proiecte</a> |
                      <a href="center">Centrul de recuperare</a> |
                      <a href="christmas">Craciunei si craciunite</a> |
                      <a href="donate">Cum donam?</a> |
                      <a href="contact">Contact</a>
                  </p>
                </div>
              </div>

              <div className="col-md-4 panel">
                <div className="panel-body">
                  <p className="text-right">
                    &copy; {new Date().getFullYear()}
                    {/* . Template by <a href="http://quip.go.ro/" rel="develop">quip.go.ro</a> */}
                  </p>
                </div>
              </div>

            </div>

          </div>
        </div>
        <a className="go-top show" href=""><i className="fa fa-angle-up"></i></a>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./app/screens/Main/footer.js